import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__deleteFinanceOrder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var order_uuid, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          order_uuid = _ref.order_uuid;
          params = {
            order_uuid: order_uuid
          };
          _context.n = 1;
          return fetcher(null, true).post('finance/cancel-order', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function api__deleteFinanceOrder(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default api__deleteFinanceOrder;